import {Button, ButtonProps} from "@mui/material";
import React, {ReactElement} from "react";

export function LargeButton(props: ButtonProps & {}): ReactElement {
  return <Button
    {...props}
    variant={props.variant || "contained"}
    style={{marginTop: "4%", fontSize: "120%", ...props.style}}/>
}